import { CIcon } from '~/icons/types'
export const ciCatalogue: CIcon = {
  width: 32,
  height: 32,
  paths: [
    {
      d:
        'M24 4.333c1.48 0 2.901.255 4.223.722a.666.666 0 0 1 .444.627v19a.668.668 0 0 1-.89.63A11.314 11.314 0 0 0 24 24.666a11.29 11.29 0 0 0-7.556 2.885.666.666 0 0 1-.888 0A11.29 11.29 0 0 0 8 24.667c-1.325 0-2.597.227-3.777.644a.669.669 0 0 1-.89-.629v-19c0-.282.179-.533.445-.627A12.65 12.65 0 0 1 8 4.333c3.034 0 5.82 1.068 8 2.847a12.616 12.616 0 0 1 8-2.847ZM8 5.667c-1.16 0-2.28.173-3.333.497v17.615a12.675 12.675 0 0 1 10.666 1.895V8.361A11.284 11.284 0 0 0 8 5.667Zm16 0a11.284 11.284 0 0 0-7.333 2.694v17.313a12.675 12.675 0 0 1 10.667-1.896V6.165A11.332 11.332 0 0 0 24 5.667Z'
    }
  ],
  name: 'catalogue',
  type: 'thin'
}
